import postAPI from './postAPI.js'

export default async function postCancelOnboardingInvite(body) {
    const data = await postAPI('admin/onboarding/invite/cancel', body);
    return data;
}
